// src/router/suporteRoutes.js
import HomeSuporte from "@/views/suporte/HomeSuporteView.vue";
import SuporteEquipamentos from "@/views/suporte/SuporteEquipamentos.vue";

export const suporteRoutes = [
  {
    path: "/suporte",
    name: "HomeSuporte",
    component: HomeSuporte,
    meta: {
      title: "Central de Suporte"
    }
  },

  {
    path: "/suporte/equipamentos",
    name: "SuporteEquipamentos",
    component: SuporteEquipamentos,
    meta: {
      title: "Suporte de Equipamentos"
    }
  },

  {
    path: "/suporte/equipamentos/instalacao",
    component: () => import("@/views/suporte/equipamentos/InstalacaoView.vue"),
    meta: {
      title: "Instalação da Máquina"
    }
  },

  {
    path: "/suporte/equipamentos/operacao",
    component: () => import("@/views/suporte/equipamentos/OperacaoView.vue"),
    meta: {
      title: "Operação da Máquina"
    }
  },

  {
    path: "/suporte/equipamentos/limpeza",
    component: () => import("@/views/suporte/equipamentos/LimpezaView.vue"),
    meta: {
      title: "Limpeza da Máquina"
    }
  },
];
